import React from "react";
// import { useHistory } from "react-router-dom";
// import ROUTES from "../../utils/routes";
import { LazyLoadImage } from "react-lazy-load-image-component";

// import { encodeNumber as nToString } from "../../API/request";

const CollectionStage = ({ title, description, image, idCollection }) => {
  // let history = useHistory();

  // const handleClick = () => {
  //   history.push(ROUTES.COLLECTIONSEMPTY + nToString(idCollection));
  // };

  return (
    <>
      <div className="collectionStage col">
        {/* <div className="collectionStage__info col-md-7">
          <span>{title}</span>
          <p>{description}</p>
          <button onClick={handleClick}>Conocer más</button>
        </div> */}
        <div className="collectionStage__image">
          <LazyLoadImage
            alt={image}
            src={process.env.REACT_APP_IMAGE_PATH + image}
          />
        </div>
      </div>
    </>
  );
};

export default CollectionStage;
